export default {
  url:
    process.env.VUE_APP_FILE_URL ||
    'https://djisamsoe-stg-assets.s3.ap-southeast-1.amazonaws.com',
};
